(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-compact-slideshow"] && !Shopify.designMode) return;
  try {
    
"use strict";

document.addEventListener("DOMContentLoaded", function() {
	document.querySelectorAll('.banner-compact-slideshow').forEach(function(bannerSlideshow) {
		const ctaBanner = bannerSlideshow.querySelector('.cta-banner-compact-slideshow button');
		const swiperContainer = bannerSlideshow.querySelector('swiper-container');

		if(ctaBanner && swiperContainer && 'initialize' in swiperContainer) {
			ctaBanner.addEventListener("click", function() {
				swiperContainer.classList.add('slideshow-blocks--open');

				lenis.stop();
			});

			const swiperParams = {
				slidesPerView: 1,
			};

			Object.assign(swiperContainer, swiperParams);

			swiperContainer.initialize();

			swiperContainer.querySelectorAll('.swiper-button').forEach(function(swiperBtn) {
				swiperBtn.addEventListener("click", function() {
					const action = swiperBtn.getAttribute('data-swiper-action') || 'next';

					if('swiper' in swiperContainer && typeof swiperContainer.swiper === 'object' && swiperContainer.swiper) {
						if(action === 'prev') {
							if(swiperContainer.swiper.isBeginning) {
								swiperContainer.classList.remove('slideshow-blocks--open');

								swiperContainer.swiper.slideTo(0);

								if(lenis) {
									lenis.start();
								}
							} else {
								swiperContainer.swiper.slidePrev();
							}
						} else {
							if(swiperContainer.swiper.isEnd) {
								swiperContainer.classList.remove('slideshow-blocks--open');

								swiperContainer.swiper.slideTo(0);

								if(lenis) {
									lenis.start();
								}
							} else {
								swiperContainer.swiper.slideNext();
							}
						}
					}
				});
			});
			
		}
	})
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-slideshow"] && !Shopify.designMode) return;
  try {
    
"use strict";

document.addEventListener("DOMContentLoaded", function() {
	document.querySelectorAll('.banner-slideshow').forEach(function(bannerSlideshow) {
		const ctaBanner = bannerSlideshow.querySelector('.cta-banner-slideshow button');
		const swiperContainer = bannerSlideshow.querySelector('swiper-container');

		if(ctaBanner && swiperContainer && 'initialize' in swiperContainer) {
			ctaBanner.addEventListener("click", function() {
				swiperContainer.classList.add('slideshow-blocks--open');

				lenis.stop();
			});

			const swiperParams = {
				slidesPerView: 1,
			};

			Object.assign(swiperContainer, swiperParams);

			swiperContainer.initialize();

			swiperContainer.querySelectorAll('.swiper-button').forEach(function(swiperBtn) {
				swiperBtn.addEventListener("click", function() {
					const action = swiperBtn.getAttribute('data-swiper-action') || 'next';

					if('swiper' in swiperContainer && typeof swiperContainer.swiper === 'object' && swiperContainer.swiper) {
						if(action === 'prev') {
							if(swiperContainer.swiper.isBeginning) {
								swiperContainer.classList.remove('slideshow-blocks--open');

								swiperContainer.swiper.slideTo(0);

								if(lenis) {
									lenis.start();
								}
							} else {
								swiperContainer.swiper.slidePrev();
							}
						} else {
							if(swiperContainer.swiper.isEnd) {
								swiperContainer.classList.remove('slideshow-blocks--open');

								swiperContainer.swiper.slideTo(0);

								if(lenis) {
									lenis.start();
								}
							} else {
								swiperContainer.swiper.slideNext();
							}
						}
					}
				});
			});
			
		}
	})
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["card-columns"] && !Shopify.designMode) return;
  try {
    
"use strict";

document.addEventListener("DOMContentLoaded", function() {
	document.querySelectorAll('.card-columns .swiper-wrapper').forEach(function(listingSlider) {
		const swiperContainer = listingSlider.querySelector('swiper-container');

		if(swiperContainer && 'initialize' in swiperContainer) {
			const swiperParams = {
				spaceBetween: 18,
				slidesPerView: 1,
                breakpoints: {
					601: {
						slidesPerView: 2,
					},
					901: {
						slidesPerView: 3
					},
				},
				navigation: {
					nextEl: '#' + listingSlider.id + ' .swiper-button-next',
					prevEl: '#' + listingSlider.id + ' .swiper-button-prev',
				},
				pagination: {
					el: '#' + listingSlider.id + ' .swiper-pagination',
					type: "progressbar",
					clickable: true,
				},
				on: {
					init() {
						listingSlider.classList.add('card-columns--slider-init');
					},
				},
			};

			Object.assign(swiperContainer, swiperParams);

			swiperContainer.initialize();
			
		}
	})
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["card-reviews"] && !Shopify.designMode) return;
  try {
    
"use strict";

document.addEventListener("DOMContentLoaded", function() {
	document.querySelectorAll('.card-reviews .swiper-wrapper').forEach(function(listingSlider) {
		const swiperContainer = listingSlider.querySelector('swiper-container');

		if(swiperContainer && 'initialize' in swiperContainer) {
			const swiperParams = {
				spaceBetween: 18,
				slidesPerView: 1,
				breakpoints: {
					601: {
						slidesPerView: 2,
					},
					901: {
						slidesPerView: 3
					},
				},
				navigation: {
					nextEl: '#' + listingSlider.id + ' .swiper-button-next',
					prevEl: '#' + listingSlider.id + ' .swiper-button-prev',
				},
				pagination: {
					el: '#' + listingSlider.id + ' .swiper-pagination',
					type: "progressbar",
					clickable: true,
				},
				on: {
					init() {
						listingSlider.classList.add('card-reviews--slider-init');
					},
				},
			};

			Object.assign(swiperContainer, swiperParams);

			swiperContainer.initialize();
			
		}
	})
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["find-products"] && !Shopify.designMode) return;
  try {
    
"use strict";

document.addEventListener("DOMContentLoaded", function() {
	document.querySelectorAll('.listing-products--slider').forEach(function(listingSlider) {
		const swiperContainer = listingSlider.querySelector('swiper-container');

		if(swiperContainer && 'initialize' in swiperContainer) {
			const slideOffset = (window.innerWidth - 1720) / 2;

			const swiperParams = {
				spaceBetween: 18,
				slidesOffsetBefore: 20,
				slidesOffsetAfter: 20,
				slidesPerView: 1.1,
				breakpoints: {
					366: {
						spaceBetween: 12,
						slidesPerView: 2.06,
						slidesOffsetBefore: 20,
						slidesOffsetAfter: 20,
					},
					601: {
						slidesPerView: 2.2,
						slidesOffsetBefore: 20,
						slidesOffsetAfter: 20,
					},
					1200: {
						slidesPerView: 3,
						slidesOffsetBefore: slideOffset > 40 ? slideOffset : 40,
						slidesOffsetAfter: slideOffset > 40 ? slideOffset : 40
					},
				},
				navigation: {
					nextEl: '#' + listingSlider.id + ' .swiper-button-next',
					prevEl: '#' + listingSlider.id + ' .swiper-button-prev',
				},
				pagination: {
					el: '#' + listingSlider.id + ' .swiper-pagination',
					type: "progressbar",
					clickable: true,
				},
				on: {
					init() {
						listingSlider.classList.add('listing-products--slider-init');
					},
				},
			};

			Object.assign(swiperContainer, swiperParams);

			swiperContainer.initialize();
			
		}
	})

	document.querySelectorAll('.collections-find-products a').forEach(function(ctaFindProducts) {
		ctaFindProducts.addEventListener('click', function(e) {
			const listingproducts = ctaFindProducts.getAttribute('data-listing-products');

			if(listingproducts) {
				e.preventDefault();

				const bgcolor = ctaFindProducts.getAttribute('data-section-bgcolor') || 'var(--color-transparent)';
				const textcolor = ctaFindProducts.getAttribute('data-section-textcolor') || 'var(--color-dark)';
				const activecolor = ctaFindProducts.getAttribute('data-section-activecolor') || 'var(--color-primary)';
				const activetextcolor = ctaFindProducts.getAttribute('data-section-activetextcolor') || 'var(--color-light)';
				const btnvariant = ctaFindProducts.getAttribute('data-section-btnvariant') || 'outline-dark';

				const listingproductsDom = document.getElementById(listingproducts);
				const sectionDom = ctaFindProducts.closest(".find-products");

				if(sectionDom) {
					sectionDom.style.setProperty("--bgcolor", bgcolor);
					sectionDom.style.setProperty("--textcolor", textcolor);
					sectionDom.style.setProperty("--activecolor", activecolor);
					sectionDom.style.setProperty("--activetextcolor", activetextcolor);

					sectionDom.querySelectorAll('[data-products-open]').forEach(function(domOpen) {
						domOpen.removeAttribute('data-products-open');
					})

					sectionDom.querySelectorAll('.collections-find-products a').forEach(function(ctaFindProduct) {
						ctaFindProduct.setAttribute('class', 'btn-' + btnvariant);
					})
				}

				if(listingproductsDom) {
					listingproductsDom.setAttribute('data-products-open', '');
				}

				ctaFindProducts.parentElement.setAttribute('data-products-open', '');
			}
		})
	})
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
"use strict";

document.addEventListener("DOMContentLoaded", function() {
	const header = document.querySelector(".site-header");

	if(!header) return false;

	const hamburgerAction = document.querySelector('[data-action="hamburger-menu"]');
	const backMenuAction = document.querySelector('[data-action="back-menu"]');
	const cartActions = document.querySelectorAll('[data-action="cart"]');
	const buttonMegamenuTargets = document.querySelectorAll('[data-megamenu-target]');
	const miniCart = document.querySelector(".mini-cart");

	header.parentElement.classList.add("header-variant--" + header.getAttribute("data-variant") || 'solid');

	let positionTop = 0;
	const styles = getComputedStyle(document.documentElement);

	function headerStickyClasses() {
		const scroll = window.scrollY;
		const heightHeader = Number(styles.getPropertyValue("--height-header").replace(/px$/, ""));

		if (scroll > heightHeader) {
			header.classList.add("sticky-active");

			if (scroll < positionTop) {
				header.classList.add("sticky-up");
				header.classList.remove("sticky-down");
			} else {
				header.classList.add("sticky-down");
				header.classList.remove("sticky-up");
			}
		} else {
			header.classList.remove("sticky-active", "sticky-up", "sticky-down");
		}

		positionTop = scroll;
	}

	headerStickyClasses();

	window.addEventListener("scroll", function () {
		headerStickyClasses();
	});


	const attrHamburger = "data-hamburger-open";
	const attrMegaMenu = "data-megamenu-open";

	if (hamburgerAction) {
		hamburgerAction.addEventListener("click", function() {
			document.querySelectorAll("[" + attrMegaMenu + "]").forEach((attrMegaMenuDom) => {
				attrMegaMenuDom.removeAttribute(attrMegaMenu);
			});

			header.toggleAttribute(attrHamburger);
		});
	}

	if(backMenuAction) {
		backMenuAction.addEventListener("click", function() {
			document.querySelectorAll("[" + attrMegaMenu + "]").forEach((attrMegaMenuDom) => {
				attrMegaMenuDom.removeAttribute(attrMegaMenu);
			});
		});
	}

	if(cartActions.length && miniCart) {
		cartActions.forEach((cartAction) => {
			cartAction.addEventListener("click", (e) => {
				e.preventDefault();
				document.body.setAttribute('data-minicart-open', '');

				if(lenis) {
					lenis.stop();
				}
			});
		});
	}

	if(buttonMegamenuTargets.length) {
		buttonMegamenuTargets.forEach((buttonMegamenuTarget) => {
			buttonMegamenuTarget.addEventListener("click", (e) => {
				const megamenuTarget = e.target.getAttribute('data-megamenu-target');

				if(megamenuTarget) {
					const megamenuTargetDom = document.getElementById(megamenuTarget);

					if(megamenuTargetDom) {
						const megamenuTargetShow = megamenuTargetDom.getAttribute(attrMegaMenu);

						if(megamenuTargetShow) {
							header.removeAttribute(attrMegaMenu);
							megamenuTargetDom.removeAttribute(attrMegaMenu);
							e.target.removeAttribute(attrMegaMenu);
						} else {
							header.setAttribute(attrMegaMenu, '');
							megamenuTargetDom.setAttribute(attrMegaMenu, 'true');
							e.target.setAttribute(attrMegaMenu, 'true');

							buttonMegamenuTargets.forEach((buttonMegamenu) => {
								if(buttonMegamenu.getAttribute('data-megamenu-target') !== megamenuTarget) {
									buttonMegamenu.removeAttribute(attrMegaMenu);
								}
							});

							document.querySelectorAll('.header_megamenu').forEach((megamenu) => {
								if(megamenu.id !== megamenuTarget) {
									megamenu.removeAttribute(attrMegaMenu);
								}
							});
						}
					}
				}
			});
		});
	}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"] && !Shopify.designMode) return;
  try {
    
"use strict";

document.addEventListener("DOMContentLoaded", function() {
	document.querySelectorAll('.listing-main-blog').forEach(function(listingBlog) {
		const totalItem = listingBlog.getAttribute('data-total-item') || 8;
		const ctaLoadMore = listingBlog.querySelector('.cta-main-blog-loadmore');

		const blogUrl = listingBlog.getAttribute('data-blog-url') || '';
		const isCurrentOpen = listingBlog.hasAttribute('data-blog-open');
		const rootElement = listingBlog.parentElement;
		const ctaTags = rootElement.querySelectorAll('.lists-tag a');

		if(ctaLoadMore) {
			const totalBlogs = listingBlog.querySelectorAll('.article-item[data-show="close"]').length;

			if(totalBlogs === 0) {
				ctaLoadMore.style.display = "none";
			}

			ctaLoadMore.addEventListener('click', function() {
				listingBlog.querySelectorAll('.article-item[data-show="close"]').forEach(function(articleItem, index) {
					if(totalItem > index) {
						articleItem.removeAttribute('data-show');
					}
				});

				const totalBlogs = listingBlog.querySelectorAll('.article-item[data-show="close"]').length;

				if(totalBlogs === 0) {
					ctaLoadMore.style.display = "none";
				}
			})
		}

		ctaTags.forEach(function(ctaTag) {
			const tagUrl = ctaTag.getAttribute('href');

			if(tagUrl) {
				if(isCurrentOpen && tagUrl === blogUrl) {
					ctaTag.setAttribute('data-blog-open', '');
				}

				const targetCTATag = rootElement.querySelector('[data-blog-url="' + tagUrl + '"]');

				ctaTag.addEventListener('click', function(e) {
					e.preventDefault();

					rootElement.querySelectorAll('[data-blog-open]').forEach(function(currentOpen) {
						currentOpen.removeAttribute('data-blog-open');
					});

					ctaTag.setAttribute('data-blog-open', '');

					if(targetCTATag) {
						targetCTATag.setAttribute('data-blog-open', '');
					}
				});
			}
		});
	});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-related"] && !Shopify.designMode) return;
  try {
    
"use strict";

document.addEventListener("DOMContentLoaded", function() {
	document.querySelectorAll('.products-related').forEach(function(productRelated) {
		const swiperContainer = productRelated.querySelector('swiper-container');

		if(swiperContainer && 'initialize' in swiperContainer) {
			const slideOffset = (window.innerWidth - 1720) / 2;

			const swiperParams = {
				spaceBetween: 18,
				slidesOffsetBefore: 20,
				slidesOffsetAfter: 20,
				slidesPerView: 1.1,
				breakpoints: {
					366: {
						spaceBetween: 12,
						slidesPerView: 2.06,
						slidesOffsetBefore: 20,
						slidesOffsetAfter: 20,
					},
					601: {
						slidesPerView: 2.2,
						slidesOffsetBefore: 20,
						slidesOffsetAfter: 20,
					},
					1200: {
						slidesPerView: 3.2,
						slidesOffsetBefore: slideOffset > 40 ? slideOffset : 40,
						slidesOffsetAfter: slideOffset > 40 ? slideOffset : 40
					},
				},
				navigation: {
					nextEl: '#' + productRelated.id + ' .swiper-button-next',
					prevEl: '#' + productRelated.id + ' .swiper-button-prev',
				},
				pagination: {
					el: '#' + productRelated.id + ' .swiper-pagination',
					type: "progressbar",
					clickable: true,
				},
				on: {
					init() {
						productRelated.classList.add('products-related--slider-init');
					},
				},
			};

			Object.assign(swiperContainer, swiperParams);

			swiperContainer.initialize();
			
		}
	})
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
"use strict";

document.addEventListener("DOMContentLoaded", function () {
	const actionMain = document.querySelector("[data-target-action]");
	const actionStickyList = document.querySelectorAll(".action-main-product--sticky");

	if (!actionMain || !actionStickyList.length) return;

	const toggleSticky = (isMainVisible) => {
		actionStickyList.forEach((actionSticky) => {
			if(isMainVisible) {
				actionSticky.classList.add("action-main-product--sticky-hide");
			} else {
				actionSticky.classList.remove("action-main-product--sticky-hide");
			}
		});
	};

	const observer = new IntersectionObserver(
		([entry]) => {
			toggleSticky(entry.isIntersecting);
		},
		{ threshold: 0, rootMargin: '100px' }
	);

	observer.observe(actionMain);
});

  } catch(e) { console.error(e); }
})();
})();
